'use client'

import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/deprecated-button'
import { Copy } from 'lucide-react'

interface InviteLinkProps {
  inviteUrl: string
  loading: boolean
  'aria-label'?: string
}

function InviteLink({ inviteUrl, loading, 'aria-label': ariaLabel }: InviteLinkProps) {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.warn('Failed to copy text: ', err)
    }
  }

  if (loading) {
    return <Input value="Loading..." readOnly className="pr-20" aria-label={ariaLabel} />
  }

  return (
    <div className="relative grow" aria-label={ariaLabel}>
      <Input value={inviteUrl} readOnly className="pr-20" />
      <Button
        onClick={copyToClipboard}
        variant="link"
        size="sm"
        className={`absolute right-1 top-1/2 -translate-y-1/2 h-[80%] px-2`}
      >
        <Copy className="w-4 h-4 mr-2" />
        {copied ? 'Copied!' : 'Copy'}
      </Button>
    </div>
  )
}

InviteLink.displayName = 'InviteLink'
export { InviteLink }
